module.exports = __webpack_public_path__ + "img/desconexionElectrica.87ea9cb8.svg";